import { s } from '../lib/style.js';

export function Hero({ v }) {
  return (
    <header id="top" style={s("position:relative;overflow:hidden;padding:clamp(70px,9vw,120px) 28px 0;")}>
      <div
        aria-hidden="true"
        style={s("position:absolute;inset:0;pointer-events:none;background:linear-gradient(180deg,#FFFFFF 0%,#F7FBFA 46%,#EBF3F2 100%);")}
      />
      <div
        aria-hidden="true"
        style={s("position:absolute;left:50%;top:clamp(110px,16vw,190px);transform:translateX(-50%);width:min(1020px,104vw);aspect-ratio:1/1;pointer-events:none;border-radius:50%;background:radial-gradient(circle at 50% 50%,rgba(91,154,150,0.26) 0%,rgba(91,154,150,0.13) 44%,rgba(91,154,150,0.05) 66%,transparent 78%);")}
      />
      <div style={s("position:relative;z-index:1;max-width:1000px;margin:0 auto;text-align:center;")}>
        <div
          style={s("display:inline-flex;align-items:center;gap:12px;background:var(--navy);border-radius:999px;padding:9px 20px;box-shadow:0 10px 24px rgba(18,49,56,0.22);font-family:var(--mono);font-weight:var(--mono-w);font-size:13px;letter-spacing:0.16em;text-transform:uppercase;color:#FFFFFF;")}
        >
          {' '}
          <span>
            Data
          </span>
          {' '}
          <span style={s("width:5px;height:5px;border-radius:50%;background:#7ACEC0;")} />
          {' '}
          <span>
            Agents
          </span>
          {' '}
          <span style={s("width:5px;height:5px;border-radius:50%;background:#7ACEC0;")} />
          {' '}
          <span>
            Teams
          </span>
          {' '}
        </div>
        <h1
          style={s("font-family:'Sofia Pro',sans-serif;font-weight:400;font-size:clamp(52px,8.6vw,104px);line-height:0.94;letter-spacing:-0.04em;margin:26px 0 0;color:var(--text);")}
        >
          A new day for
          <br />
          <span style={s(v.kwLight)}>
            brand teams.
          </span>
        </h1>
        <p
          style={s("max-width:640px;margin:26px auto 0;font-size:clamp(17.5px,1.8vw,20px);line-height:1.6;color:var(--muted);")}
        >
          The work of running a brand is scattered — disconnected data, silos across teams and agencies, slow manual process.
          {' '}
          <span style={s("color:var(--text);font-weight:600;")}>
            BrandBase
          </span>
          {' '}
          is the agentic AI operating system that brings data, agents, and teams into one intelligent foundation.
        </p>
        <div style={s("display:flex;flex-wrap:wrap;gap:12px;justify-content:center;margin-top:34px;")}>
          {' '}
          <a
            className="hv-5"
            href="#waitlist"
            style={s("text-decoration:none;background:linear-gradient(135deg,#123138 0%,#1E4D50 55%,#2E7A72 100%);color:#FFFFFF;padding:16px 32px;border-radius:999px;font-size:17px;font-weight:500;letter-spacing:-0.01em;box-shadow:0 10px 26px rgba(18,49,56,0.26), 0 2px 0 rgba(255,255,255,0.18) inset;transition:transform .2s ease, box-shadow .2s ease;")}
          >
            {v.ctaLabel}
          </a>
          {' '}
          <a
            className="hv-6"
            href="#platform"
            style={s("text-decoration:none;border:1px solid var(--line);background:rgba(18,49,56,0.035);color:var(--text);padding:15px 28px;border-radius:999px;font-size:17px;font-weight:500;")}
          >
            See how it works
          </a>
          {' '}
        </div>
      </div>
      <div style={s("position:relative;z-index:1;max-width:1120px;margin:clamp(48px,6vw,76px) auto 0;")}>
        <div
          style={s("border:1px solid var(--line);border-radius:18px 18px 0 0;background:#FFFFFF;box-shadow:0 -1px 0 rgba(91,154,150,0.25) inset, 0 40px 100px rgba(18,49,56,0.5);overflow:hidden;")}
        >
          <div
            style={s("display:flex;align-items:center;gap:14px;padding:13px 18px;border-bottom:1px solid var(--line);background:#FFFFFF;")}
          >
            <div style={s("display:flex;gap:6px;")}>
              {' '}
              <span style={s("width:9px;height:9px;border-radius:50%;background:rgba(18,49,56,0.16);")} />
              {' '}
              <span style={s("width:9px;height:9px;border-radius:50%;background:rgba(18,49,56,0.16);")} />
              {' '}
              <span style={s("width:9px;height:9px;border-radius:50%;background:rgba(18,49,56,0.16);")} />
              {' '}
            </div>
            <div
              style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:12.5px;color:var(--muted);letter-spacing:0.06em;")}
            >
              brandbase — Ridgeline Provisions workspace
            </div>
            {' '}
            <button
              type="button"
              aria-label="Toggle workspace menu"
              onClick={v.toggleMockNav}
              style={s(v.mockToggle)}
            >
              {' '}
              <span
                aria-hidden="true"
                style={s("display:block;width:15px;height:1.6px;border-radius:2px;background:var(--text);")}
              />
              {' '}
              <span
                aria-hidden="true"
                style={s("display:block;width:15px;height:1.6px;border-radius:2px;background:var(--text);")}
              />
              {' '}
              <span
                aria-hidden="true"
                style={s("display:block;width:15px;height:1.6px;border-radius:2px;background:var(--text);")}
              />
              {' '}
            </button>
            {' '}
          </div>
          <div
            style={s(`display:grid;${v.mockGrid ?? ""}background:#F4F8F7;font-family:'Sofia Pro',sans-serif;`)}
          >
            <div style={s(v.mockSidePanel)}>
              <div>
                <div style={s("display:flex;align-items:center;gap:8px;")}>
                  <span
                    style={s("width:18px;height:18px;border-radius:50%;background:linear-gradient(160deg,#7ACEC0,#1B4A48);flex:0 0 auto;")}
                  />
                  <span style={s("font-size:18px;font-weight:700;color:#FFFFFF;letter-spacing:-0.02em;")}>
                    BrandBase
                  </span>
                </div>
                <div style={s("font-size:11px;color:rgba(234,243,241,0.55);margin-top:4px;")}>
                  Ridgeline Provisions
                </div>
                <div aria-hidden="true" style={s("display:flex;gap:5px;margin-top:10px;")}>
                  <span style={s("width:16px;height:2px;border-radius:2px;background:#2E7A72;")} />
                  <span style={s("width:16px;height:2px;border-radius:2px;background:#5B9A96;")} />
                  <span style={s("width:16px;height:2px;border-radius:2px;background:#7ACEC0;")} />
                </div>
              </div>
              <div style={s("display:flex;flex-direction:column;gap:2px;")}>
                <div
                  style={s("display:flex;align-items:center;gap:9px;padding:7px 10px;border-radius:8px;font-size:13px;background:rgba(255,255,255,0.10);font-weight:600;color:#FFFFFF;")}
                >
                  <svg
                    aria-hidden="true"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={s("flex:0 0 auto;")}
                  >
                    <path d="M4 10.5 12 4l8 6.5V20H4z" />
                  </svg>
                  Home
                </div>
                <div
                  style={s("display:flex;align-items:center;gap:9px;padding:7px 10px;border-radius:8px;font-size:13px;color:rgba(234,243,241,0.68);")}
                >
                  <svg
                    aria-hidden="true"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={s("flex:0 0 auto;")}
                  >
                    <path d="M6 3v18M6 4h11l-2 4 2 4H6" />
                  </svg>
                  Needs you
                </div>
              </div>
              <div style={s("display:flex;flex-direction:column;gap:5px;")}>
                <div
                  style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.12em;color:rgba(234,243,241,0.42);padding-left:10px;")}
                >
                  YOUR AGENTS
                </div>
                <div
                  style={s("display:flex;align-items:center;gap:9px;padding:4px 10px;font-size:13px;color:rgba(234,243,241,0.82);")}
                >
                  <span
                    style={s("width:17px;height:17px;border-radius:5px;background:#123138;color:#EAF3F1;font-size:9px;display:flex;align-items:center;justify-content:center;font-weight:700;flex:0 0 auto;")}
                  >
                    B
                  </span>
                  Business Review
                </div>
                <div
                  style={s("display:flex;align-items:center;gap:9px;padding:4px 10px;font-size:13px;color:rgba(234,243,241,0.82);")}
                >
                  <span
                    style={s("width:17px;height:17px;border-radius:5px;background:#1B4A48;color:#EAF3F1;font-size:9px;display:flex;align-items:center;justify-content:center;font-weight:700;flex:0 0 auto;")}
                  >
                    A
                  </span>
                  Analyst
                </div>
                <div
                  style={s("display:flex;align-items:center;gap:9px;padding:4px 10px;font-size:13px;color:rgba(234,243,241,0.82);")}
                >
                  <span
                    style={s("width:17px;height:17px;border-radius:5px;background:#2E7A72;color:#EAF3F1;font-size:9px;display:flex;align-items:center;justify-content:center;font-weight:700;flex:0 0 auto;")}
                  >
                    D
                  </span>
                  Data Operations
                </div>
                <div
                  style={s("display:flex;align-items:center;gap:9px;padding:4px 10px;font-size:13px;color:rgba(234,243,241,0.82);")}
                >
                  <span
                    style={s("width:17px;height:17px;border-radius:5px;background:#3E8C84;color:#EAF3F1;font-size:9px;display:flex;align-items:center;justify-content:center;font-weight:700;flex:0 0 auto;")}
                  >
                    R
                  </span>
                  Risk & Opportunity
                </div>
                <div
                  style={s("display:flex;align-items:center;gap:9px;padding:4px 10px;font-size:13px;color:rgba(234,243,241,0.82);")}
                >
                  <span
                    style={s("width:17px;height:17px;border-radius:5px;background:#5B9A96;color:#0B1F23;font-size:9px;display:flex;align-items:center;justify-content:center;font-weight:700;flex:0 0 auto;")}
                  >
                    I
                  </span>
                  Market Intelligence
                </div>
                <div
                  style={s("display:flex;align-items:center;gap:9px;padding:4px 10px;font-size:13px;color:rgba(234,243,241,0.82);")}
                >
                  <span
                    style={s("width:17px;height:17px;border-radius:5px;background:#7ACEC0;color:#0B1F23;font-size:9px;display:flex;align-items:center;justify-content:center;font-weight:700;flex:0 0 auto;")}
                  >
                    P
                  </span>
                  Planning
                </div>
                <div
                  style={s("display:flex;align-items:center;gap:9px;padding:4px 10px;font-size:13px;color:rgba(234,243,241,0.82);")}
                >
                  <span
                    style={s("width:17px;height:17px;border-radius:5px;background:#9EDBD1;color:#0B1F23;font-size:9px;display:flex;align-items:center;justify-content:center;font-weight:700;flex:0 0 auto;")}
                  >
                    M
                  </span>
                  Brand Memory
                </div>
                <div
                  style={s("display:flex;align-items:center;gap:9px;padding:4px 10px;font-size:13px;color:rgba(234,243,241,0.82);")}
                >
                  <span
                    style={s("width:17px;height:17px;border-radius:5px;background:#C3E9E2;color:#0B1F23;font-size:9px;display:flex;align-items:center;justify-content:center;font-weight:700;flex:0 0 auto;")}
                  >
                    S
                  </span>
                  Brand Steward
                </div>
              </div>
              <div style={s("display:flex;flex-direction:column;gap:7px;")}>
                <div
                  style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.12em;color:rgba(234,243,241,0.42);padding-left:10px;")}
                >
                  WORKSPACE
                </div>
                <div
                  style={s("display:flex;flex-direction:column;gap:6px;padding-left:10px;font-size:13px;color:rgba(234,243,241,0.68);")}
                >
                  <div style={s("display:flex;align-items:center;gap:9px;")}>
                    <svg
                      aria-hidden="true"
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={s("flex:0 0 auto;")}
                    >
                      <path d="M12 4v16M4 12h16M6.5 6.5l11 11M17.5 6.5l-11 11" />
                    </svg>
                    Skills
                  </div>
                  <div style={s("display:flex;align-items:center;gap:9px;")}>
                    <svg
                      aria-hidden="true"
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={s("flex:0 0 auto;")}
                    >
                      <path d="M9 3v5M15 3v5M7 8h10v3a5 5 0 0 1-10 0zM12 16v5" />
                    </svg>
                    Connectors
                  </div>
                  <div style={s("display:flex;align-items:center;gap:9px;")}>
                    <svg
                      aria-hidden="true"
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={s("flex:0 0 auto;")}
                    >
                      <ellipse cx="12" cy="6" rx="7" ry="3" />
                      <path d="M5 6v6c0 1.7 3.1 3 7 3s7-1.3 7-3V6M5 12v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6" />
                    </svg>
                    Data
                  </div>
                  <div style={s("display:flex;align-items:center;gap:9px;")}>
                    <svg
                      aria-hidden="true"
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={s("flex:0 0 auto;")}
                    >
                      <path d="M5 5h14M5 12h14M5 19h9" />
                    </svg>
                    Activity feed
                  </div>
                  <div style={s("display:flex;align-items:center;gap:9px;")}>
                    <svg
                      aria-hidden="true"
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={s("flex:0 0 auto;")}
                    >
                      <circle cx="12" cy="12" r="3" />
                      <path
                        d="M12 3v3M12 18v3M4.5 7.5l2.1 2.1M17.4 14.4l2.1 2.1M3 12h3M18 12h3M4.5 16.5l2.1-2.1M17.4 9.6l2.1-2.1"
                      />
                    </svg>
                    Settings
                  </div>
                </div>
              </div>
              <div style={s("margin-top:auto;display:flex;flex-direction:column;gap:10px;")}>
                <div
                  style={s("display:flex;align-items:center;gap:9px;border:1px solid rgba(255,255,255,0.14);border-radius:10px;padding:9px 11px;background:rgba(255,255,255,0.06);")}
                >
                  {' '}
                  <span
                    aria-hidden="true"
                    style={s("width:15px;height:15px;border-radius:50%;border:2px solid #7ACEC0;border-right-color:rgba(122,206,192,0.25);flex:0 0 auto;")}
                  />
                  {' '}
                  <span style={s("font-size:12px;color:#FFFFFF;font-weight:600;")}>
                    Getting started
                  </span>
                  <span style={s("font-size:12px;color:rgba(234,243,241,0.42);")}>
                    · 6/9
                  </span>
                  {' '}
                </div>
                <div
                  style={s("display:flex;align-items:center;gap:9px;padding-top:10px;border-top:1px solid rgba(255,255,255,0.12);")}
                >
                  {' '}
                  <span
                    style={s("width:22px;height:22px;border-radius:50%;background:#1B4A48;color:#EAF3F1;font-size:9px;font-weight:700;display:flex;align-items:center;justify-content:center;flex:0 0 auto;")}
                  >
                    CB
                  </span>
                  {' '}
                  <div style={s("min-width:0;")}>
                    <div style={s("font-size:12.5px;font-weight:600;color:#FFFFFF;")}>
                      Claire Bennett
                    </div>
                    <div style={s("font-size:10.5px;color:rgba(234,243,241,0.5);")}>
                      Business Development
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={s("position:relative;padding:26px 30px 34px;display:flex;flex-direction:column;gap:20px;min-width:0;")}
            >
              <div
                aria-hidden="true"
                style={s("position:absolute;top:22px;right:0;display:flex;flex-direction:column;align-items:center;gap:7px;padding:12px 7px;border-radius:10px 0 0 10px;background:var(--navy);")}
              >
                {' '}
                <span style={s("width:13px;height:13px;border-radius:50%;border:1.5px solid #7ACEC0;")} />
                {' '}
                <span
                  style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:9.5px;letter-spacing:0.14em;text-transform:uppercase;color:#9EDBD1;writing-mode:vertical-rl;")}
                >
                  Agents
                </span>
                {' '}
              </div>
              <div
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;color:#93A5A3;letter-spacing:0.04em;")}
              >
                Ridgeline Provisions /
                {' '}
                <span style={s("color:var(--navy);")}>
                  Home
                </span>
              </div>
              <div>
                <div style={s("font-size:27px;font-weight:700;color:var(--navy);letter-spacing:-0.025em;")}>
                  Good morning, Claire.
                </div>
                <div
                  style={s("font-size:13.5px;line-height:1.55;color:#4B5551;margin-top:10px;max-width:560px;text-wrap:pretty;")}
                >
                  This is where you run Ridgeline Provisions — the performance picture, the risks and opportunities under the number, and your AI agents, all in one place.
                </div>
                <div
                  style={s("display:flex;flex-wrap:wrap;align-items:center;gap:10px;margin-top:12px;font-size:11.5px;color:#7C8C8B;")}
                >
                  Grounded in
                  {' '}
                  <span style={s("display:inline-flex;align-items:center;gap:5px;")}>
                    <span
                      style={s("width:15px;height:15px;border-radius:4px;background:#123138;color:#EAF3F1;font-size:8.5px;display:flex;align-items:center;justify-content:center;font-weight:700;")}
                    >
                      TO
                    </span>
                    Internal data
                  </span>
                  {' '}
                  <span style={s("display:inline-flex;align-items:center;gap:5px;")}>
                    <span
                      style={s("width:15px;height:15px;border-radius:4px;background:#2E7A72;color:#EAF3F1;font-size:8.5px;display:flex;align-items:center;justify-content:center;font-weight:700;")}
                    >
                      SN
                    </span>
                    Snowflake (SQL API)
                  </span>
                  {' '}
                </div>
              </div>
              <div
                style={s("display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:10px;border:1px solid rgba(18,49,56,0.10);border-radius:10px;padding:13px 16px;background:#FFFFFF;")}
              >
                <div style={s("display:flex;flex-wrap:wrap;align-items:center;gap:10px;font-size:13px;")}>
                  <span
                    style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.1em;color:#93A5A3;")}
                  >
                    GETTING STARTED
                  </span>
                  <span style={s("font-weight:600;color:var(--navy);")}>
                    Teach it your look
                  </span>
                  <span style={s("color:#93A5A3;")}>
                    6/9
                  </span>
                </div>
                {' '}
                <span style={s("font-size:12.5px;color:var(--mint);font-weight:600;")}>
                  Open guide ›
                </span>
                {' '}
              </div>
              <div style={s("display:flex;flex-direction:column;gap:9px;min-width:0;")}>
                <div
                  style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.12em;color:#93A5A3;")}
                >
                  START SOMETHING
                </div>
                <div
                  style={s("display:grid;grid-template-columns:repeat(auto-fit,minmax(min(300px,100%),1fr));gap:9px;")}
                >
                  <div
                    style={s("border:1px solid rgba(18,49,56,0.10);border-radius:10px;padding:13px 15px;background:#FFFFFF;display:grid;grid-template-columns:auto minmax(0,1fr);gap:11px;")}
                  >
                    <span style={s("grid-row:span 2;padding-top:2px;color:#5B9A96;display:flex;")}>
                      <svg
                        aria-hidden="true"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={s("flex:0 0 auto;")}
                      >
                        <path d="M12 3 4 7.5l8 4.5 8-4.5z" />
                        <path d="M4 13l8 4.5 8-4.5" />
                      </svg>
                    </span>
                    <div style={s("font-size:13.5px;font-weight:600;color:var(--navy);")}>
                      How's our distribution and velocity trending?
                    </div>
                    <div style={s("font-size:12px;color:#7C8C8B;margin-top:4px;")}>
                      Straight from your unified data — no setup, no Excel
                    </div>
                  </div>
                  <div
                    style={s("border:1px solid rgba(18,49,56,0.10);border-radius:10px;padding:13px 15px;background:#FFFFFF;display:grid;grid-template-columns:auto minmax(0,1fr);gap:11px;")}
                  >
                    <span style={s("grid-row:span 2;padding-top:2px;color:#5B9A96;display:flex;")}>
                      <svg
                        aria-hidden="true"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={s("flex:0 0 auto;")}
                      >
                        <path d="M4 20V4M4 20h16M8 16v-5M12.5 16V8M17 16v-3" />
                      </svg>
                    </span>
                    <div style={s("font-size:13.5px;font-weight:600;color:var(--navy);")}>
                      Chart this month's paid social + lifecycle performance
                    </div>
                    <div style={s("font-size:12px;color:#7C8C8B;margin-top:4px;")}>
                      Meta Ads + Klaviyo, in one chart
                    </div>
                  </div>
                  <div
                    style={s("border:1px solid rgba(18,49,56,0.10);border-radius:10px;padding:13px 15px;background:#FFFFFF;display:grid;grid-template-columns:auto minmax(0,1fr);gap:11px;")}
                  >
                    <span style={s("grid-row:span 2;padding-top:2px;color:#5B9A96;display:flex;")}>
                      <svg
                        aria-hidden="true"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={s("flex:0 0 auto;")}
                      >
                        <path d="M7 3h7l4 4v14H7z" />
                        <path d="M14 3v4h4M10 12h6M10 16h6" />
                      </svg>
                    </span>
                    <div style={s("font-size:13.5px;font-weight:600;color:var(--navy);")}>
                      Draft the MBR in our template
                    </div>
                    <div style={s("font-size:12px;color:#7C8C8B;margin-top:4px;")}>
                      Pulls in the reads above, on-brand
                    </div>
                  </div>
                </div>
              </div>
              <div style={s("display:flex;flex-direction:column;gap:9px;min-width:0;")}>
                <div
                  style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.12em;color:#93A5A3;")}
                >
                  NEEDS YOU
                </div>
                <div
                  style={s("border:1px solid rgba(18,49,56,0.10);border-radius:10px;padding:13px 15px;background:#FFFFFF;display:grid;grid-template-columns:auto minmax(0,1fr);gap:11px;")}
                >
                  <span style={s("grid-row:span 2;padding-top:2px;color:#5B9A96;display:flex;")}>
                    <svg
                      aria-hidden="true"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={s("flex:0 0 auto;")}
                    >
                      <path d="M6 3v18M6 4h11l-2 4 2 4H6" />
                    </svg>
                  </span>
                  <div style={s("font-size:13.5px;font-weight:600;color:var(--navy);")}>
                    Nothing waiting on you
                  </div>
                  <div style={s("font-size:12px;color:#7C8C8B;margin-top:4px;")}>
                    Risk flags and agent approvals show up here — open
                    {' '}
                    <span style={s("color:var(--navy);font-weight:600;")}>
                      Needs you
                    </span>
                    {' '}
                    anytime.
                  </div>
                </div>
              </div>
              <div style={s("display:flex;flex-direction:column;gap:9px;min-width:0;")}>
                <div
                  style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.12em;color:#93A5A3;")}
                >
                  PINNED ARTIFACTS
                </div>
                <div
                  style={s("border:1px solid rgba(18,49,56,0.10);border-radius:10px;padding:13px 15px;background:#FFFFFF;display:grid;grid-template-columns:auto minmax(0,1fr);gap:11px;")}
                >
                  <span style={s("grid-row:span 2;padding-top:2px;color:#5B9A96;display:flex;")}>
                    <svg
                      aria-hidden="true"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={s("flex:0 0 auto;")}
                    >
                      <path d="M7 3h10v18l-5-4-5 4z" />
                    </svg>
                  </span>
                  <div style={s("font-size:13.5px;font-weight:600;color:var(--navy);")}>
                    Nothing pinned yet
                  </div>
                  <div style={s("font-size:12px;color:#7C8C8B;margin-top:4px;")}>
                    Build a draft with the agent, then hit
                    {' '}
                    <span style={s("color:var(--navy);font-weight:600;")}>
                      Pin
                    </span>
                    {' '}
                    on the artifact to keep it here.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
